import React, { useState } from 'react';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Mesajınız alındı! En kısa sürede sizinle iletişime geçeceğiz.');
    setFormData({ name: '', phone: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="iletisim" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            İletişim
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Sorularınız ve rezervasyonlarınız için bizimle iletişime geçin
          </p>
          <div className="w-20 h-1 bg-blue-500 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h3 className="text-2xl font-semibold text-white mb-8">
              Bize Ulaşın
            </h3>
            
            <div className="space-y-6">
              {/* Phone */}
              <a
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-4 p-4 bg-slate-800/50 border border-slate-700 rounded-xl hover:border-blue-500/50 transition-colors duration-300 group"
              >
                <div className="w-12 h-12 bg-blue-600/20 rounded-lg flex items-center justify-center group-hover:bg-blue-600/30 transition-colors">
                  <Phone className="w-6 h-6 text-blue-400" />
                </div>
                <div>
                  <div className="text-slate-400 text-sm">Telefon</div>
                  <div className="text-white font-semibold text-lg">{companyInfo.phone}</div>
                </div>
              </a>

              {/* Email */}
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-4 p-4 bg-slate-800/50 border border-slate-700 rounded-xl hover:border-blue-500/50 transition-colors duration-300 group"
              >
                <div className="w-12 h-12 bg-blue-600/20 rounded-lg flex items-center justify-center group-hover:bg-blue-600/30 transition-colors">
                  <Mail className="w-6 h-6 text-blue-400" />
                </div>
                <div>
                  <div className="text-slate-400 text-sm">E-posta</div>
                  <div className="text-white font-semibold text-lg">{companyInfo.email}</div>
                </div>
              </a>

              {/* Address */}
              <div className="flex items-center gap-4 p-4 bg-slate-800/50 border border-slate-700 rounded-xl">
                <div className="w-12 h-12 bg-blue-600/20 rounded-lg flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-blue-400" />
                </div>
                <div>
                  <div className="text-slate-400 text-sm">Adres</div>
                  <div className="text-white font-semibold text-lg">{companyInfo.address}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8">
            <h3 className="text-xl font-semibold text-white mb-6">
              Mesaj Gönderin
            </h3>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-slate-300 mb-2 text-sm font-medium">
                  Adınız Soyadınız
                </label>
                <Input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-blue-500"
                  placeholder="Adınızı girin"
                />
              </div>
              <div>
                <label className="block text-slate-300 mb-2 text-sm font-medium">
                  Telefon Numaranız
                </label>
                <Input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-blue-500"
                  placeholder="05XX XXX XX XX"
                />
              </div>
              <div>
                <label className="block text-slate-300 mb-2 text-sm font-medium">
                  Mesajınız
                </label>
                <Textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={4}
                  className="bg-slate-900/50 border-slate-600 text-white placeholder:text-slate-500 focus:border-blue-500 resize-none"
                  placeholder="Mesajınızı yazın..."
                />
              </div>
              <Button
                type="submit"
                className="w-full bg-blue-600 hover:bg-blue-500 text-white py-3 font-semibold"
              >
                <Send className="w-5 h-5 mr-2" />
                Gönder
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
